import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-part-travaux',
    templateUrl: './part-travaux.component.html',
    styleUrls: ['./part-travaux.component.scss']
})
export class PartTravauxComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }

}
